module.exports = __webpack_public_path__ + "static/img/top_bg_url.f5f8a790.png";